export const faqs = [{
  q: '¿Necesito saber coser o hacer manualidades?',
  a: 'No necesitás ser especialista. El kit está pensado para acompañar el armado en familia. Revisá los pasos y los materiales del proyecto elegido antes de comenzar.'
}, {
  q: '¿Todos los disfraces son de terror?',
  a: 'No. El Tomo 1 reúne propuestas tenebrosas y el Tomo 2 incluye personajes divertidos y simpáticos.'
}, {
  q: '¿Los materiales se consiguen en Argentina?',
  a: 'Las propuestas utilizan materiales habituales, como cartón, papel, cartulina, telas y goma EVA, según el proyecto. Revisá cada lista antes de comprar.'
}, {
  q: '¿Qué recibo con la compra?',
  a: 'Dos tomos de 40 páginas y cinco bonus de 12 páginas cada uno: siete archivos PDF y 140 páginas en total. Es un producto digital.'
}, {
  q: '¿Necesito imprimir todo?',
  a: 'No. Podés consultar las guías desde un celular, una tablet o una computadora e imprimir las páginas que necesites.'
}, {
  q: '¿Los chicos pueden hacerlo solos?',
  a: 'El kit propone una actividad acompañada. Una persona adulta debe supervisar y realizar las tareas que requieran herramientas, calor o elementos cortantes. Adaptá la participación a la edad de cada chico.'
}, {
  q: '¿Incluye los materiales o el disfraz terminado?',
  a: 'No. La compra incluye los archivos PDF. Los materiales y el armado corren por cuenta de cada familia.'
}, {
  q: '¿Cómo recibo los archivos?',
  a: 'La entrega es inmediata: apenas se confirma el pago, recibís el material en formato PDF mediante el sistema de entrega informado en el checkout.'
}, {
  q: '¿Qué medios de pago aceptan?',
  a: 'Podés pagar con Mercado Pago, con los medios que la plataforma tenga disponibles al momento de tu compra.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí. Tenés 7 días de garantía desde la compra. Si el kit no es lo que esperabas, escribinos a soporte dentro de ese plazo y te devolvemos el dinero.'
}, {
  q: '¿Qué pasa si tengo un problema con los archivos?',
  a: 'Contactá al soporte indicado en tu comprobante de compra para solicitar ayuda con la entrega o la apertura de los archivos.'
}];